import * as React from 'react';

const IconDwnl = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#1B1F23" />
      <path d="M8 13L12 9H9V4H7V9H4L8 13Z" fill="white" />
    </svg>
  );
};

export default IconDwnl;
